export const convertContainerData = (arr) => {
  let result = []
  if (arr && arr.length > 0) {
    arr.map((item, index) => result.push({ id: item.id, containerNumber: item.containerNumber }))
  }
  return result
}